import style from './index.module.scss';
import React from 'react';
import {
    getTaskResultPage,
    ResultType,
    ResultTypeMap,
    TaskResultListItem,
} from '../../../service';
import {Button} from 'antd';
import useModalHandler from '../../../../../Utils/Hooks/useModalHandler';
import {SortOrder} from 'antd/es/table/interface';
import MultiLineColumn from '../../../Components/MultiLineColumn';
import dayjs from 'dayjs';
import LogDetailModal from './components/LogDetailModal';
import useTable from '../../../../../Utils/Hooks/useTable';
import TableRender, {ProColumnsType} from 'table-render';

export interface searchItem {
    status?: ResultType; //执行结果
    name?: string; //名称及编码
}

export default function LogList() {
    const {tableInit} = useTable(getTaskResultPage, {});
    const modal = useModalHandler({
        component: LogDetailModal,
    });

    const sortDirections: SortOrder[] = ['descend', 'ascend'];

    const openLog = (eid: string) => {
        modal.open({
            eid,
        });
    };

    const columns: ProColumnsType<TaskResultListItem> = [
        {
            title: 'id',
            dataIndex: 'id',
            align: 'center',
        },
        {
            title: '名称及编码',
            dataIndex: 'code',
            align: 'left',
            width: 120,
            render: (text: string, record: TaskResultListItem) => (
                <MultiLineColumn name={record.name} no={text} />
            ),
        },

        {
            title: '执行时间',
            dataIndex: 'createTime',
            align: 'center',
            sortDirections: sortDirections,
            sorter: (a, b) => dayjs(a.createTime).diff(b.createTime),
            render: (text: string) => (
                <div>
                    {text ? dayjs(text).format('YY-MM-DD HH:mm:ss') : '--'}
                </div>
            ),
        },
        {
            title: '处理数据量',
            dataIndex: 'num',
            align: 'center',
        },
        {
            title: '执行结果',
            dataIndex: 'status',
            align: 'center',
            render: (text: ResultType) => (
                <div
                    style={{
                        color: text === ResultType.Error ? 'red' : '#333',
                    }}>
                    {ResultTypeMap[text]}
                </div>
            ),
        },
        {
            title: '操作',
            align: 'center',
            render: (record: TaskResultListItem) => {
                return (
                    <div>
                        <Button type="link" onClick={() => openLog(record.eid)}>
                            查看日志
                        </Button>
                    </div>
                );
            },
        },
    ];

    const schema = {
        type: 'object',
        labelWidth: 130,
        properties: {
            name: {
                title: '名称及编号',
                type: 'string',
            },
            status: {
                title: '执行结果',
                type: 'string',
                widget: 'select',
                props: {
                    options: [
                        {label: '全部', value: ResultType.All},
                        {label: '执行成功', value: ResultType.Success},
                        {label: '执行中', value: ResultType.Doing},
                        {label: '执行失败', value: ResultType.Error},
                    ],
                },
            },
        },
    };

    return (
        <div className={style.root}>
            <TableRender
                columns={columns}
                rowKey="id"
                search={{schema}}
                {...tableInit()}
            />
            {modal.render()}
        </div>
    );
}
